import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLineageosComponent } from './simple-icons-lineageos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLineageosComponent ],
    exports:      [ SimpleIconsLineageosComponent ],
    bootstrap:    []
})
export class SimpleIconsLineageosModule {}
